document.addEventListener('DOMContentLoaded', function () {
  console.warn('Calculator.js loaded');
  const openModalButton = document.getElementById('openCalculatorModal');

  if (!openModalButton) {
    return;
  } else {

    const calculatorModal = document.getElementById('calculatorModal');
    const closeModalButton = document.getElementById('closeCalculatorModal');
    const squareMetersInput = document.getElementById('squareMeters');
    const boxContentSpan = document.getElementById('boxContent');
    const errorMessage = document.getElementById('errorMessage');
    const boxesNeededOutput = document.getElementById('boxesNeeded');
    const boxPriceOutput = document.getElementById('boxPrice');
    const totalSquareMetersOutput = document.getElementById('totalSquareMeters');
    const addToCartButton = document.getElementById('addToCartButton');
    const totalPriceText = document.querySelector('#totalPrice');

    let boxesNeeded = 0;

    // Función para convertir punto a coma en decimales
    function formatDecimal(value) {
      return value.toString().replace('.', ',');
    }

    // Función para actualizar la información de la variante
    function updateVariantInfo() {
      const variantId = document.querySelector('input[name="id"]')?.value || document.querySelector('.calculator-container').dataset.variantId;
      const dataEl = document.getElementById('variant-superficies');

      if (!dataEl) return;

      const jsonData = JSON.parse(dataEl.innerText);
      console.log('Buscando variante:', variantId);
      console.log('Variantes disponibles:', jsonData.variants);

      // Convertir variantId a string para la comparación
      const found = jsonData.variants.find(v => v.id.toString() === variantId.toString());
      console.log('Variante encontrada:', found);

      if (found) {
        const superficie = parseFloat(found.superficie_en_m2) || 0;
        const precioConImpuestos = parseFloat(found.precio)*1.21 || 0;
        const precio = parseFloat(found.precio) || 0;
        const precioCaja = parseFloat(found.precio_caja) || 0;



        const variantTitle = found.title || '';
        const productTitle = document.querySelector('.product-title').textContent.trim();

        console.log('Actualizando con valores:', {
          superficie,
          precioConImpuestos,
          precio,
          precioCaja,
          variantTitle,
          productTitle
        });

        document.getElementById('boxContent').textContent = superficie.toString();
        document.querySelector('[data-calc-price]').setAttribute('data-calc-price', precio.toString());
        document.getElementById('pricePerMeter').textContent = new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: 'EUR'
        }).format(precioConImpuestos);

        document.getElementById('boxPrice').textContent = new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: 'EUR'
        }).format(precioCaja);

        // Actualizar el subtítulo con el nuevo título de la variante
        const subtitleElement = document.getElementById('calculatorSubtitle');
        subtitleElement.textContent = `${productTitle} / ${variantTitle}`;
        console.log('Subtítulo actualizado a:', subtitleElement.textContent);

        // Actualizar el ID de la variante en el contenedor
        document.querySelector('.calculator-container').dataset.variantId = found.id;
      } else {
        console.warn('No se encontró la variante:', variantId);
      }
    }

    // Escuchar cambios en los selectores de variantes (radio buttons)
    const variantSelectors = document.querySelectorAll('.variant-picker__option input[type="radio"]');
    console.log('Selectores de variantes encontrados:', variantSelectors.length);

    variantSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        console.log('Cambio detectado en selector de variante');
        updateVariantInfo();
      });
    });

    // Algunos temas emiten este evento cuando cambia variante
    document.addEventListener('variant:changed', (event) => {
      console.log('Evento variant:changed detectado', event);
      updateVariantInfo();
    });

    // Observar cambios en el input[name="id"] del form de producto
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      if (variantIdInput) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              console.log('Cambio detectado en el ID de la variante');
              updateVariantInfo();
            }
          });
        });

        observer.observe(variantIdInput, {
          attributes: true
        });
      }
    }

    // Abrir modal al hacer clic en el botón
    openModalButton.addEventListener('click', function () {
      updateVariantInfo();
      calculatorModal.classList.remove('hidden');
    });

    // Cerrar modal al hacer clic en “X”
    closeModalButton.addEventListener('click', function () {
      calculatorModal.classList.add('hidden');
    });

    // Cerrar modal al hacer clic fuera del contenido
    window.addEventListener('click', function (event) {
      if (event.target === calculatorModal) {
        calculatorModal.classList.add('hidden');
      }
    });

    // Evento al teclear metros en el input
    squareMetersInput.addEventListener('input', function () {
      const squareMeters = parseFloat(squareMetersInput.value.replace(',', '.'));
      const SQUARE_METERS_PER_BOX = parseFloat(boxContentSpan.textContent.replace(',', '.'));
      const precioM2 = parseFloat(document.querySelector('[data-calc-price]').getAttribute('data-calc-price'));
      const precioM2ConImpuestos = precioM2 * 1.21;

      console.log('Valores de entrada:', {
        squareMeters,
        SQUARE_METERS_PER_BOX,
        precioM2
      });

      if (isNaN(squareMeters) || squareMeters <= 0) {
        errorMessage.textContent = 'Debe ingresar una cantidad válida de metros cuadrados.';
        boxesNeededOutput.textContent = '0';
        boxPriceOutput.textContent = '0 €';
        totalSquareMetersOutput.textContent = '0';
        totalPriceText.textContent = '0 €';
        boxesNeeded = 0;
        return;
      }

      if (SQUARE_METERS_PER_BOX <= 0) {
        errorMessage.textContent = 'Error: El contenido de la caja debe ser mayor que 0';
        return;
      }

      // 1. Calcular cajas necesarias (redondeando hacia arriba)
      boxesNeeded = Math.ceil(squareMeters / SQUARE_METERS_PER_BOX);

      // 2. Calcular metros cuadrados totales que cubrirá
      const totalSquareMeters = boxesNeeded * SQUARE_METERS_PER_BOX;

      // 3. Calcular precio total (TOTAL m² que cubrirá * precio por m2)
      const totalPrice = totalSquareMeters * (precioM2ConImpuestos || 0);

      console.log('Valores calculados:', {
        boxesNeeded,
        totalSquareMeters,
        totalPrice,
        precioM2
      });

      // Mostrar resultados
      errorMessage.textContent = '';
      boxesNeededOutput.textContent = boxesNeeded;
      totalSquareMetersOutput.textContent = formatDecimal(totalSquareMeters.toFixed(2));
      document.getElementById('pricePerMeter').textContent = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }).format(precioM2ConImpuestos);
      totalPriceText.textContent = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }).format(totalPrice);
    });

    // Añadir al carrito usando Cart.js
    addToCartButton.addEventListener('click', function () {
      if (boxesNeeded === 0) {
        errorMessage.textContent = 'Por favor, ingrese una cantidad válida de metros cuadrados antes de agregar al carrito.';
        return;
      }

      const variantId = document.querySelector('.calculator-container').dataset.variantId;

      if (variantId) {
        CartJS.addItem(variantId, boxesNeeded, {}, {
          "success": function(data) {
            console.log('Producto añadido al carrito:', data);
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
            document.querySelector('cart-drawer').setAttribute('open', '');
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          },
          "error": function(error) {
            console.error('Error al añadir el producto al carrito:', error);
          }
        });
      } else {
        console.error('No se pudo obtener el ID de la variante del producto.');
      }
    });
  }
});
